export default __webpack_public_path__ + "static/media/bxl-tailwind-css.9e622dd9.svg";